{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              7.650390008200759,
              43.762008965400696
            ],
            [
              6.659837966185819,
              45.349056395274374
            ],
            [
              2.694833829160615,
              43.29162445920804
            ],
            [
              2.5052586537567834,
              42.380705009915886
            ],
            [
              3.4105762117771974,
              42.44430360026675
            ],
            [
              6.499814537007381,
              42.592199273150186
            ],
            [
              7.650390008200759,
              43.762008965400696
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}